import React from 'react';
import {
    Button,
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import {
    onAdminQuantityChange,
    onFieldUserQuantityChange,
} from './TimesheetDetail';
import { areTimesSet } from './CrewTimesheet';

export default class TimesheetDetailBulkChange extends React.Component {
    constructor(props) {
        super(props);

        this.state = { quantity: 0, showModal: false };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    onApplyChange = () => {
        const { quantity } = this.state;

        const { timesheet, isAdmin, onTimesheetMutated, contractPhase, job } =
            this.props;

        timesheet.timesheetDetails.forEach((td) => {
            if (isAdmin) {
                onAdminQuantityChange(
                    timesheet,
                    job,
                    contractPhase.id,
                    td.id,
                    quantity
                );
            } else {
                onFieldUserQuantityChange(
                    timesheet,
                    contractPhase.id,
                    td.id,
                    quantity
                );
            }
        });

        onTimesheetMutated(timesheet);

        this.setState({ quantity: 0, showModal: false });
    };

    getIsValid = () => {
        const { quantity } = this.state;

        return Boolean(quantity && !isNaN(quantity) && Number(quantity) > 0);
    };

    render() {
        const { loading, job, isReadOnly, contractPhase, timesheet } =
            this.props;

        const { quantity, showModal } = this.state;

        if (loading || !job || isReadOnly) {
            return null;
        }

        const isValid = this.getIsValid();

        const isDisabled = !areTimesSet(timesheet);

        return (
            <div className="text-center">
                <Button
                    className="mt-3 w-50"
                    color="info"
                    outline
                    onClick={this.toggleModal}
                    disabled={isDisabled}
                >
                    Set All
                </Button>
                <Modal
                    isOpen={showModal}
                    fade={false}
                    autoFocus={false}
                    size="xl"
                >
                    <ModalHeader toggle={this.toggleModal}>
                        Setting time for all components for{' '}
                        {contractPhase.displayPhase} -{' '}
                        {contractPhase.description}
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <div>
                                Please enter the hours worked for{' '}
                                {contractPhase.displayPhase} (
                                {contractPhase.description}).
                            </div>
                            <div>
                                <InputGroup>
                                    <Input
                                        type="number"
                                        inputMode="decimal"
                                        step={0.25}
                                        value={quantity}
                                        onChange={(e) =>
                                            this.setState({
                                                quantity: e.target.value,
                                            })
                                        }
                                        autoFocus={true}
                                        disabled={isReadOnly}
                                    />
                                    <InputGroupText>hrs</InputGroupText>
                                </InputGroup>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter hidden={isReadOnly}>
                        <Button
                            type="button"
                            onClick={this.onApplyChange}
                            color="success"
                            outline={!isValid}
                            disabled={!isValid}
                        >
                            Update All
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
